import { useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      toast.success("If that email exists, a reset link was sent.");
      if (data.reset_link) setLink(data.reset_link);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="font-display text-3xl tracking-tight">Forgot password</h1>
      <p className="text-sm text-slate-600 mt-2">We'll email you a reset link.</p>
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
        <input className="input-base" type="email" required placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} data-testid="forgot-email" />
        <button className="btn-primary w-full" data-testid="forgot-submit">Send reset link</button>
      </form>
      {link && <p className="mt-4 text-xs text-slate-600 break-all">Dev link: <a href={link} className="underline">{link}</a></p>}
    </div>
  );
}
